import config from 'config'
import Home from '../views/Home.vue'
import Single from '../views/Single.vue'
import NotFound from '../views/NotFound.vue'
import CookieConsentModal from '../views/CookieConsentModal.vue'
import CookieConsentCguModal from '../views/CookieConsentCguModal.vue'
import CookieConsentVideoModal from '../views/CookieConsentVideoModal.vue'
import { RouteConfig } from 'vue-router'

let routes = [
  {
    path: '/single',
    name: 'Single',
    component: Single
  },
  {
    path: '/:lang?',
    name: 'Home',
    component: Home
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
] as RouteConfig[]

if (config.cookies) {
  routes = [
    {
      path: '/cookie-modal',
      name: 'CookieConsentModal',
      component: CookieConsentModal,
      meta: { layout: 'iframe' }
    },
    {
      path: '/cookie-cgu',
      name: 'CookieConsentCguModal',
      component: CookieConsentCguModal,
      meta: { layout: 'iframe' }
    },
    {
      path: '/cookie-modal-video',
      name: 'CookieConsentVideoModal',
      component: CookieConsentVideoModal,
      meta: { layout: 'iframe' }
    },
    ...routes
  ]
}

export default routes
